
const getMessageIds = (generalMessageData) => (
	generalMessageData.keySeq().toArray()
);

const getMessageById = (generalMessageData) => (messageId) => {
	return generalMessageData.get(messageId);
}

export {getMessageIds, getMessageById}